import React from 'react';
import { 
  Grid, Volume2, Activity, Users, Settings, Smartphone, Shield, GraduationCap 
} from 'lucide-react';

interface MobileAppNavigationProps {
  activeTab: string;
  onTabChange: (tab: 'modules' | 'aac' | 'student_portal' | 'school_admin' | 'analytics' | 'landing') => void;
  currentUser?: any;
}

export const MobileAppNavigation: React.FC<MobileAppNavigationProps> = ({
  activeTab,
  onTabChange,
  currentUser
}) => {
  const tabs = [
    { id: 'modules', label: 'Modules', icon: Grid, badge: '30' },
    { id: 'aac', label: 'AAC Board', icon: Volume2 },
    { id: 'student_portal', label: 'Student Portal', icon: GraduationCap, highlight: true },
    { id: 'school_admin', label: 'Roster', icon: Users },
    { id: 'analytics', label: 'Audit BI', icon: Activity }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-lg border-t border-slate-800 px-2 py-2 flex items-center justify-around shadow-2xl">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id as any)}
            className={`flex-1 py-1.5 flex flex-col items-center justify-center gap-0.5 rounded-xl transition transform active:scale-95 relative ${
              isActive ? 'text-amber-400 font-extrabold' : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            {isActive && (
              <span className="absolute -top-2 w-8 h-1 bg-amber-400 rounded-full shadow-lg shadow-amber-400/50" />
            )}
            
            <div className="relative">
              <Icon className={`w-5 h-5 ${isActive ? 'text-amber-400' : tab.highlight ? 'text-amber-300' : 'text-slate-400'}`} />
              {tab.badge && (
                <span className="absolute -top-1.5 -right-2 px-1 py-0.2 bg-amber-500 text-slate-950 text-[9px] font-black rounded-full">
                  {tab.badge}
                </span>
              )}
            </div>
            
            <span className={`text-[10px] tracking-tight ${tab.highlight && !isActive ? 'text-amber-300 font-bold' : ''}`}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
